import { useLocation } from 'react-router-dom';

export const useQueryParam = (param: string): null | string => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  return query.get(param);
};

export const useIntQueryParam = (param: string): null | number => {
  const value = useQueryParam(param);
  return value ? parseInt(value, 10) : null;
};
